import {createSelector} from 'reselect';
import {AppState} from '../../index';

export const privilegesSelector = () =>
  createSelector(
    (state: AppState) => state.privilege.privileges,
    (item) => item,
  );
